import React, { useEffect, useState } from 'react';
import { system_notification } from 'src/store/slice/system';
import store from 'src/storeWire';
import { FilterSelection } from 'src/reusable/global';
import { useQuoteFilterSelectionStore } from 'src/hooks/component/quote-filter-selection';
import System from 'src/helper/system';
import Common from 'src/pages/Quote/Common';

export function QuoteDetailSearchFilter() {
    const [formData, setFormData] = useState({ searchBy: '', searchVal: '' })
    const [{ }, { }, { set_filter_list }] = useQuoteFilterSelectionStore();

    const [validateDetail, setValidateDetail] = useState([])

    const ddlValues = [
        { id: "manufacturerPartNumber", text: "Manufacturer Part Number" },
        { id: "customerPartNumber", text: "Customer Part Number" },
    ];

    const onValueChange = (value) => {
        setFormData({ ...formData, searchVal: value })
        validateOnChange(value);
    }
    const validateOnChange = (value) => {
        if (value) {
            const isValid = Common.validateMinCharacter(value);
            if (isValid) {
                let validateData = { ...validateDetail };
                delete validateData.searchVal;
                setValidateDetail(validateData)
            }
        }

    }

    const onSearchChange = (e) => {
        setFormData({ ...formData, searchBy: e.target.value })
        if (e.target.value) {
            let validateData = { ...validateDetail };
            delete validateData.searchBy;
            setValidateDetail(validateData)
        }
    }

    const onSearch = (e) => {
        const isValid = validateData();

        if (isValid) {
            const detail = {
                searchKey: formData.searchBy,
                searchKeyword: formData.searchVal.trim(),
                searchType: ddlValues.find(f => f.id === formData.searchBy).text
            }
            set_filter_list([detail]);
        }
    }

    const validateData = () => {
        if (!formData.searchBy) {
            setValidateDetail({ searchBy: 'Please select a "search by" option' })
            return false
        }

        if (!formData.searchVal) {
            setValidateDetail({ searchVal: 'Search value is required' })
            return false
        } else {
            const isValid = Common.validateMinCharacter(formData.searchVal);
            if (isValid === false) {
                setValidateDetail({ searchVal: 'Please enter at least 3 characters to execute a keyword search' });
                return false
            }
        }
        return true;
    }

    return (
        <>
            <h4>Quote Breakdown</h4>
            <div className="d-flex align-items-top mb-4">
                <div>
                    <div className="dropdown quote-search-dd me-3">
                        <div className="selectbox">
                            <select className="form-control form-control-sm mr-3" aria-label="Search By" id="searchBy" onChange={onSearchChange} defaultValue={formData.searchBy} >
                                <option value="" key="3" >Search By</option>
                                {ddlValues && (ddlValues).map((v, i) => (
                                    <option key={v.id} value={v.id}>{v.text}</option>
                                ))}
                            </select>
                        </div>
                        {validateDetail?.searchBy && <p className="error">{validateDetail?.searchBy}</p>}
                    </div>
                </div>
                <div>
                    <div className="bs5 input-group flex-nowrap">
                        <input type="search" className="form-control form-control-sm"
                            placeholder="Enter keyword, item, model or part number."
                            value={formData.searchVal}
                            onChange={({ target: { value } }) => onValueChange(value)}
                            onKeyPress={(e) => System.onEnterKeyPress(e) === true ? onSearch() : ''} />

                        <a href={void (0)} className="bs5 btn btn-secondary d-flex align-items-center rounded-right-1" onClick={onSearch}>
                            <i className="fa fa-search text-black-stone  text-black-stone"></i>
                        </a>
                    </div>
                    {validateDetail?.searchVal && <p className="error">{validateDetail?.searchVal}</p>}
                </div>
                <div className="bs5 ms-2 mt-1 pt-1">
                    <a href={void (0)}
                        onClick={() => {
                            store.dispatch(system_notification({
                                name: 'QuoteDetailFilterPopup',
                                data: [],
                            }));
                        }}>Advanced Filters</a>
                </div>
            </div>
            <FilterSelection />
        </>
    );

}

